import { TimeReportingPage } from './time-reporting';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DatePipe, SlicePipe, CommonModule } from '@angular/common';
import { StateCellPipe } from '../../pipes/state-cell.pipe';

import { CommonHeaderComponentModule } from '../../components/common-header/common-header.module';
import { StateFooterComponentModule } from './../../components/state-footer/state-footer.module';
import { HalfDayBlockComponentModule } from './../../components/halfday-block/halfday-block.module';

import { ModalEditPageModule } from '../modal-edit/modal-edit.module';

@NgModule({
  declarations: [
    TimeReportingPage,
    StateCellPipe
  ],
  imports: [
    CommonHeaderComponentModule,
    CommonModule,
    HalfDayBlockComponentModule,
    ModalEditPageModule,
    StateFooterComponentModule,
    IonicPageModule.forChild(TimeReportingPage),
  ],
  exports: [
    TimeReportingPage,
    SlicePipe
  ],
  providers: [
    DatePipe
  ]
})
export class TimeReportingModule { }


// WEBPACK FOOTER //
// ./src/pages/time-reporting/time-reporting.module.ts